import { Alert as UIAlert } from '@celltrak/ui-components';

import { useAlert } from '../../../Common/hooks';

import styles from './Alert.module.scss';

const Alert = () => {
  const { alert, hideAlert } = useAlert();

  return (
    <div className={styles.alert}>
      <UIAlert color={alert.color} isOpen={alert.show} onClose={() => hideAlert()}>
        {alert.icon ? <i className={`fa fa-${alert.icon} ${styles.icon}`} /> : null}
        {alert.message}
      </UIAlert>
    </div>
  );
};

export default Alert;
